import {
  Loader,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";

import type { RosterSummary } from "../../types";

import { RosterListItem } from "./roster-list-item";

export type RostersListProps = {
  rosters: RosterSummary[];
  isLoading: boolean;
};

export const RostersList = ({ rosters, isLoading }: RostersListProps) => {
  if (isLoading) {
    return (
      <Stack sx={{ position: "relative", minHeight: "10rem" }}>
        <Loader centered />
      </Stack>
    );
  }

  if (!rosters.length) {
    return (
      <Typography
        component="p"
        variant="paragraph"
        sx={{ color: "var(--grey-2)", fontStyle: "italic" }}
      >
        No rosters match your filters.
      </Typography>
    );
  }

  return (
    <Stack sx={{ gap: 1 }}>
      {rosters.map((roster, index) => (
        <RosterListItem
          key={roster.id}
          roster={roster}
          animationDelayMs={Math.min(index, 8) * 30}
        />
      ))}
    </Stack>
  );
};
